// Parse JSON without throwing - returns null on malformed input or null/empty
// string. Used by the external-widget modules to read persisted state out of
// localStorage where a corrupted value should degrade silently to "no state".
export function gracefulJsonParse<T>(json: string | null): T | null {
  try {
    if (json) {
      return JSON.parse(json) as T;
    }
  } catch {
    // ignore - corrupted localStorage value
  }
  return null;
}
